import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { EmailValidator, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatError, MatFormField, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { LoginHeaderComponent } from '../../shared/components/login-header/login-header.component';
import { FooterComponent } from '../../shared/components/app-footer/footer.component';
import { CustomErrorStateMatcher } from '../../core/models/CustomErrorStateMatcher';
import { MatDialog } from '@angular/material/dialog';
import { LoginService } from '../../core/services/Login/login.service';
import { DialogComponent } from '../../shared/components/dialogbox/dialog/dialog.component';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule,
    MatLabel,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatFormField,
    MatError,
    MatInputModule,
    MatButtonModule,
    LoginHeaderComponent,
    FooterComponent],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {

  matcher = new CustomErrorStateMatcher();
  dialog = inject(MatDialog);
  forgotPasswordForm: FormGroup;
  formValues: any;
  loginService = inject(LoginService);
  loginFailedMessage: string;
  constructor(private fb: FormBuilder) {

    this.forgotPasswordForm = this.fb.group({
      userID: new FormControl('', Validators.email)

    });

  }
  onSubmit() {
    this.formValues = this.forgotPasswordForm.value;
    this.loginService.forgotPassword(this.formValues).subscribe({
      next: (response: any) => {
        if (response.responseCode === "1000") {
          this.forgotPasswordForm.reset();
          this.dialog.open(DialogComponent, {
            data: {
              title: 'Success',
              message: response.responseMessage 
            }
          });
        } else {
          this.dialog.open(DialogComponent, {
            data: {
              title: 'Error',
              message: response.responseMessage 
            }
          });
        }
      },
      error: error => {
        this.dialog.open(DialogComponent, {
          minWidth: '300px',
          data: {
            message: error.error.responseMessage,
          },
        });
      }
    });
  }
}
